var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header", { ref: "child" }),
      _vm._v(" "),
      _c("Navigation", { attrs: { page: _vm.page } }),
      _vm._v(" "),
      _c("div", { staticClass: "frailty-risk-body" }, [
        _vm.page === 1
          ? _c("div", { staticClass: "basic-data-page1 page-height" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "question-group" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("体重")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hearings.weight,
                          expression: "hearings.weight"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.hearings,
                            "weight",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(100, function(n) {
                      return _c("option", { key: n, domProps: { value: n } }, [
                        _vm._v(_vm._s(n))
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v(".")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.decimalPoint,
                          expression: "decimalPoint"
                        }
                      ],
                      staticClass: "decimalPoint",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.decimalPoint = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(10, function(n) {
                      return _c("option", { key: n, domProps: { value: n } }, [
                        _vm._v(_vm._s(n - 1))
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "unit" }, [_vm._v("Kg")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("身長")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hearings.height,
                          expression: "hearings.height"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.hearings,
                            "height",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(200, function(n) {
                      return _c("option", { key: n, domProps: { value: n } }, [
                        _vm._v(_vm._s(n))
                      ])
                    }),
                    0
                  ),
                  _c("span", { staticClass: "unit" }, [_vm._v("cm")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("屈伸回数")]),
                  _c("span", { staticClass: "warning" }, [
                    _vm._v("※10秒間のうち")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.hearings.stretch,
                          expression: "hearings.stretch"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.hearings,
                            "stretch",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(16, function(n) {
                      return _c("option", { key: n, domProps: { value: n } }, [
                        _vm._v(_vm._s(n - 1))
                      ])
                    }),
                    0
                  ),
                  _c("span", { staticClass: "unit" }, [_vm._v("回")]),
                  _c("br"),
                  _vm._v(" "),
                  _c("label", { staticClass: "error-text" }, [
                    _vm._v("※無理のない範囲で行ってください")
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 2
          ? _c(
              "div",
              { staticClass: "basic-data-page2 page-height" },
              _vm._l(_vm.hearings.hearing_check, function(item, index) {
                return _c("div", { key: item.content, attrs: { id: index } }, [
                  item.Number === 0
                    ? _c(
                        "div",
                        { staticClass: "question-group button-style" },
                        [
                          _c("p", {
                            staticClass: "text-style",
                            domProps: {
                              innerHTML: _vm._s(
                                item.content
                                  .replace(/　/g, "<br/>")
                                  .replace(/@/g, "<span class=gray-text>")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.yes,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.yes)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.yes
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("はい")])
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.no,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.no)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.no
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("いいえ")])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 3
          ? _c(
              "div",
              { staticClass: "basic-data-page2 page-height" },
              _vm._l(_vm.hearings.hearing_check, function(item, index) {
                return _c("div", { key: item.content, attrs: { id: index } }, [
                  item.Number === 1
                    ? _c(
                        "div",
                        { staticClass: "question-group button-style" },
                        [
                          _c("p", {
                            staticClass: "text-style",
                            domProps: {
                              innerHTML: _vm._s(
                                item.content
                                  .replace(/　/g, "<br/>")
                                  .replace(/@/g, "<span class=gray-text>")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.yes,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.yes)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.yes
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("はい")])
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.no,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.no)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.no
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("いいえ")])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 4
          ? _c(
              "div",
              { staticClass: "basic-data-page2 page-height" },
              _vm._l(_vm.hearings.hearing_check, function(item, index) {
                return _c("div", { key: item.content, attrs: { id: index } }, [
                  item.Number === 2
                    ? _c(
                        "div",
                        { staticClass: "question-group button-style" },
                        [
                          _c("p", {
                            staticClass: "text-style",
                            domProps: {
                              innerHTML: _vm._s(
                                item.content
                                  .replace(/　/g, "<br/>")
                                  .replace(/@/g, "<span class=gray-text>")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.yes,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.yes)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.yes
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("はい")])
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.no,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.no)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.no
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("いいえ")])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 5
          ? _c(
              "div",
              { staticClass: "basic-data-page2 page-height" },
              _vm._l(_vm.hearings.hearing_check, function(item, index) {
                return _c("div", { key: item.content, attrs: { id: index } }, [
                  item.Number === 3
                    ? _c(
                        "div",
                        { staticClass: "question-group button-style" },
                        [
                          _c("p", {
                            staticClass: "text-style",
                            domProps: {
                              innerHTML: _vm._s(
                                item.content
                                  .replace(/　/g, "<br/>")
                                  .replace(/@/g, "<span class=gray-text>")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.yes,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.yes)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.yes
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("はい")])
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.no,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.no)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.no
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("いいえ")])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 6
          ? _c(
              "div",
              { staticClass: "basic-data-page2 page-height" },
              _vm._l(_vm.hearings.hearing_check, function(item, index) {
                return _c("div", { key: item.content, attrs: { id: index } }, [
                  item.Number === 4
                    ? _c(
                        "div",
                        { staticClass: "question-group button-style" },
                        [
                          _c("p", {
                            staticClass: "text-style",
                            domProps: {
                              innerHTML: _vm._s(
                                item.content
                                  .replace(/　/g, "<br/>")
                                  .replace(/@/g, "<span class=gray-text>")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.yes,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.yes)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.yes
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("はい")])
                          ]),
                          _vm._v(" "),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.hearingId[item.id],
                                  expression: "hearingId[item.id]"
                                }
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: _vm.no,
                                checked: _vm._q(_vm.hearingId[item.id], _vm.no)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(
                                    _vm.hearingId,
                                    item.id,
                                    _vm.no
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v("いいえ")])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c("router-link", { attrs: { to: "/other" } }, [
            _vm.page === 1
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/meal_history/アセット 20@2x.png")
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.page > 1
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 4@2x.png") },
                on: { click: _vm.prev }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 1 && this.hearings.stretch === false
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
              })
            : _vm.page === 1
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
                on: { click: _vm.next }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 2 && Object.keys(this.hearingId).length < 3
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
              })
            : _vm.page === 2
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
                on: { click: _vm.next }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 3 && Object.keys(this.hearingId).length < 6
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
              })
            : _vm.page === 3
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
                on: { click: _vm.next }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 4 && Object.keys(this.hearingId).length < 9
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
              })
            : _vm.page === 4
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
                on: { click: _vm.next }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 5 && Object.keys(this.hearingId).length < 12
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
              })
            : _vm.page === 5
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
                on: { click: _vm.next }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.page === 6 && Object.keys(this.hearingId).length < 15
            ? _c("img", {
                staticClass: "inactive_img",
                attrs: { src: require("@/assets/sign_up/アセット 55@2x.png") }
              })
            : _vm.page === 6
            ? _c("img", {
                attrs: { src: require("@/assets/sign_up/アセット 55@2x.png") },
                on: { click: _vm.pushedComplete }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showContent,
            expression: "showContent"
          }
        ],
        on: { pushedCancel: _vm.hideContent, "handle-submit": _vm.submit }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", { staticClass: "text-style" }, [
        _vm._v("\n          今月の"),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticClass: "turquoise-blue" }, [
          _vm._v("基本データ・健康度チェック")
        ]),
        _c("br"),
        _vm._v("を入力しましょう。\n        ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-992575c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992575c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FrailtyRiskCheck.vue
// module id = null
// module chunks = 